import { verifyLogin } from 'util/cache'
import { useDocTitle } from 'util/hooks'

import { SearchBar } from 'components/search-bar'
import { SearchResults } from 'components/search-results'
import React, { useState, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { LessonsContextProvider } from 'ai-generated/lessons-context'

export const Lessons = () => {
	const navigate = useNavigate()
	const [searchParams] = useSearchParams()
	const classId = searchParams.get('classId') || undefined

	const [ query, setQuery ] = useState("")

	useEffect(() => {
		verifyLogin(navigate)
	}, [navigate])

	useDocTitle('All for One - Lessons')

	return (
		<LessonsContextProvider query={query}>
			<h1 style={{
				fontSize: '2rem',
				fontWeight: 700,
				letterSpacing: '-0.02em',
				background: 'linear-gradient(135deg, var(--blue), var(--teal))',
				WebkitBackgroundClip: 'text',
				WebkitTextFillColor: 'transparent',
				backgroundClip: 'text',
				textAlign: 'center',
				marginBottom: '32px',
				marginTop: '40px'
			}}>
				My Lesson Library
			</h1>
			<SearchBar
				placeholder="Search for lessons"
				onChange={({ target }) => setQuery(target.value)}
			/>
			<SearchResults query={query} classId={classId}/>
		</LessonsContextProvider>
	)
}
